var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: "foreSpeak(PH)", "is-show-follow": false },
              on: { opened: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vvLBlNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.voyageNoBlNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: true,
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.vvLBlNo,
                                    callback: function ($$v) {
                                      _vm.vvLBlNo = $$v
                                    },
                                    expression: "vvLBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentStatus"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.paymentStatusText,
                                    disabled: true,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.select"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "forespeakStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.forespeakStatus"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.forespeakStatusText,
                                    disabled: true,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.select"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "consigneeName",
                                  label: _vm.$t(
                                    "blExchangeAppointment.consigneeName"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 500,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.consigneeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consigneeName", $$v)
                                    },
                                    expression: "form.consigneeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "mail",
                                  label: _vm.$t("blExchangeAppointment.mail"),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 500,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.mail,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mail", $$v)
                                    },
                                    expression: "form.mail",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.hasFree && _vm.isCredit !== "Y"
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.bankSlip"
                                      ),
                                      prop: "bankSlip",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "bankSlip",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadSharedBankSlip(
                                              file
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: { type: "primary" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasFree && _vm.isCredit !== "Y"
                      ? _c(
                          "div",
                          { staticClass: "fee-section-wrapper" },
                          _vm._l(_vm.filteredLocalFees, function (row, index) {
                            return _c(
                              "el-row",
                              { key: index, attrs: { gutter: 24 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "reqired",
                                        attrs: {
                                          label: _vm.$t(
                                            "blExchangeAppointment.payDate"
                                          ),
                                          prop:
                                            "localFees[" +
                                            index +
                                            "].paymentDate",
                                          rules: {
                                            required: true,
                                            message: _vm.$t("home.placehold"),
                                            trigger: "change",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            format: "yyyy-MM-dd",
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            placeholder: _vm.$t(
                                              "blExchangeAppointment.payDate"
                                            ),
                                            disabled: row.feeStatus === 1,
                                          },
                                          model: {
                                            value: row.paymentDate,
                                            callback: function ($$v) {
                                              _vm.$set(row, "paymentDate", $$v)
                                            },
                                            expression: "row.paymentDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "reqired",
                                        attrs: {
                                          prop:
                                            "localFees[" +
                                            index +
                                            "].paymentMethod",
                                          rules: {
                                            required: true,
                                            message: _vm.$t("home.placehold"),
                                            trigger: "change",
                                          },
                                          label: _vm.$t("home.paidType"),
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              disabled: row.feeStatus === 1,
                                            },
                                            model: {
                                              value: row.paymentMethod,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row,
                                                  "paymentMethod",
                                                  $$v
                                                )
                                              },
                                              expression: "row.paymentMethod",
                                            },
                                          },
                                          _vm._l(
                                            _vm.paidTypeList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label:
                                                    _vm.language === "zh"
                                                      ? item.labelCN
                                                      : item.labelEh,
                                                  value: Number(item.value),
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                row.paymentMethod === 1 ||
                                row.paymentMethod === "1"
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 2 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              prop:
                                                "localFees[" +
                                                index +
                                                "].paymentBank",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                              label: _vm.$t(
                                                "blExchangeAppointment.paymentBank"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  disabled: row.feeStatus === 1,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleBankChange(
                                                      row,
                                                      index,
                                                      "localFees"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: row.paymentBank,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      row,
                                                      "paymentBank",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.paymentBank",
                                                },
                                              },
                                              _vm._l(
                                                _vm.phEdoBankList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.codeValue,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.displayValueCn
                                                          : item.displayValue,
                                                      value: item.codeValue,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                row.paymentMethod === 1 ||
                                row.paymentMethod === "1"
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 3 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass:
                                              "reqired account-label",
                                            attrs: {
                                              prop:
                                                "localFees[" +
                                                index +
                                                "].paymentAccount",
                                              label:
                                                row.paymentBank === "BDO"
                                                  ? _vm.$t(
                                                      "blExchangeAppointment.bankRefNo"
                                                    )
                                                  : _vm.$t(
                                                      "blExchangeAppointment.paymentAccount"
                                                    ),
                                              rules: [
                                                {
                                                  required: true,
                                                  message:
                                                    _vm.$t("home.placehold"),
                                                  trigger: ["change", "blur"],
                                                },
                                                {
                                                  validator:
                                                    _vm.validatePaymentAccount,
                                                  trigger: [
                                                    "change",
                                                    "blur",
                                                    "input",
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength:
                                                  row.paymentBank === "BDO"
                                                    ? 10
                                                    : 15,
                                                placeholder: _vm.$t(
                                                  "blExchangeAppointment.pleaseInput"
                                                ),
                                                disabled: row.feeStatus === 1,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.handlePaymentAccountInput(
                                                    $event,
                                                    row,
                                                    index,
                                                    "localFees"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.paymentAccount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "paymentAccount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "row.paymentAccount",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "reqired",
                                        attrs: {
                                          prop:
                                            "localFees[" +
                                            index +
                                            "].paymentCurrency",
                                          rules: {
                                            required: true,
                                            message: _vm.$t("home.placehold"),
                                            trigger: "change",
                                          },
                                          label: _vm.$t(
                                            "blExchangeAppointment.currency"
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              disabled: row.feeStatus === 1,
                                            },
                                            model: {
                                              value: row.paymentCurrency,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  row,
                                                  "paymentCurrency",
                                                  $$v
                                                )
                                              },
                                              expression: "row.paymentCurrency",
                                            },
                                          },
                                          _vm._l(
                                            _vm.currencyList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label:
                                                    _vm.language === "zh"
                                                      ? item.labelCN
                                                      : item.labelEh,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "reqired",
                                        attrs: {
                                          prop:
                                            "localFees[" +
                                            index +
                                            "].paymentAmount",
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t("home.placehold"),
                                              trigger: "change",
                                            },
                                            {
                                              validator: function (
                                                rule,
                                                value,
                                                callback
                                              ) {
                                                return _vm.validateAmount(
                                                  rule,
                                                  value,
                                                  callback
                                                )
                                              },
                                              trigger: "change",
                                            },
                                          ],
                                          label: _vm.$t(
                                            "blExchangeAppointment.paymentAmount"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "blExchangeAppointment.pleaseInput"
                                            ),
                                            disabled: row.feeStatus === 1,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.handleAmountInput(
                                                $event,
                                                row,
                                                "paymentAmount"
                                              )
                                            },
                                          },
                                          model: {
                                            value: row.paymentAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row,
                                                "paymentAmount",
                                                $$v
                                              )
                                            },
                                            expression: "row.paymentAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "reqired",
                                        attrs: {
                                          prop:
                                            "localFees[" +
                                            index +
                                            "].invoiceNumber",
                                          rules: {
                                            required: true,
                                            message: _vm.$t("home.placehold"),
                                            trigger: "change",
                                          },
                                          label: _vm.$t(
                                            "blExchangeAppointment.invoiceNumber"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "blExchangeAppointment.pleaseInput"
                                            ),
                                            disabled: true,
                                          },
                                          model: {
                                            value: row.invoiceNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row,
                                                "invoiceNumber",
                                                $$v
                                              )
                                            },
                                            expression: "row.invoiceNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 3 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-top": "5px",
                                        display: "flex",
                                        "flex-direction": "column",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        height: "100%",
                                        gap: "5px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "90px" },
                                          attrs: { type: "primary" },
                                          on: { click: _vm.addLocalFeesRow },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "blExchangeAppointment.addBtn"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            width: "90px",
                                            "margin-right": "10px",
                                          },
                                          attrs: {
                                            type: "danger",
                                            disabled: row.feeStatus === 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeLocalFeesRow(
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "blExchangeAppointment.delBtn"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasDemurrage && _vm.isCredit !== "Y"
                      ? [
                          _c(
                            "div",
                            { staticClass: "fee-section-wrapper" },
                            _vm._l(
                              _vm.filteredDemurrageFees,
                              function (row, index) {
                                return _c(
                                  "el-row",
                                  { key: index, attrs: { gutter: 24 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 3 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              label: _vm.$t(
                                                "blExchangeAppointment.demurrageReceipt"
                                              ),
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].attachmentId",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                ref:
                                                  "demurrageReceiptUpload-" +
                                                  index,
                                                refInFor: true,
                                                staticClass: "upload-demo",
                                                attrs: {
                                                  action: "",
                                                  limit: 1,
                                                  "http-request": function (
                                                    file
                                                  ) {
                                                    return _vm.uploadDemurrageFeeFile(
                                                      file,
                                                      index
                                                    )
                                                  },
                                                  "on-remove": function (file) {
                                                    return _vm.handleDemurrageFeeFileRemove(
                                                      file,
                                                      index
                                                    )
                                                  },
                                                  "before-remove":
                                                    _vm.beforeRemove,
                                                  "before-upload":
                                                    _vm.beforeUpload,
                                                  "file-list":
                                                    _vm.getDemurrageFeeFileList(
                                                      row
                                                    ),
                                                  "on-preview":
                                                    _vm.handleDownload,
                                                  disabled: row.feeStatus === 1,
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "btn-primary",
                                                    attrs: {
                                                      type: "primary",
                                                      size: "mini",
                                                      disabled:
                                                        row.feeStatus === 1,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "blExchangeAppointment.uploadAttachment"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 3 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              label: _vm.$t(
                                                "blExchangeAppointment.payDate"
                                              ),
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].paymentDate",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "date",
                                                format: "yyyy-MM-dd",
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                                placeholder: _vm.$t(
                                                  "blExchangeAppointment.payDate"
                                                ),
                                                disabled: row.feeStatus === 1,
                                              },
                                              model: {
                                                value: row.paymentDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "paymentDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.paymentDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 2 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].paymentMethod",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                              label: _vm.$t("home.paidType"),
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  disabled: row.feeStatus === 1,
                                                },
                                                model: {
                                                  value: row.paymentMethod,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      row,
                                                      "paymentMethod",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.paymentMethod",
                                                },
                                              },
                                              _vm._l(
                                                _vm.paidTypeList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.labelCN
                                                          : item.labelEh,
                                                      value: Number(item.value),
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    row.paymentMethod === 1 ||
                                    row.paymentMethod === "1"
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 2 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "reqired",
                                                attrs: {
                                                  prop:
                                                    "demurrageFees[" +
                                                    index +
                                                    "].paymentBank",
                                                  rules: {
                                                    required: true,
                                                    message:
                                                      _vm.$t("home.placehold"),
                                                    trigger: "change",
                                                  },
                                                  label: _vm.$t(
                                                    "blExchangeAppointment.paymentBank"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      clearable: "",
                                                      disabled:
                                                        row.feeStatus === 1,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleBankChange(
                                                          row,
                                                          index,
                                                          "demurrageFees"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: row.paymentBank,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          row,
                                                          "paymentBank",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.paymentBank",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.phEdoBankList,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.codeValue,
                                                        attrs: {
                                                          label:
                                                            _vm.language ===
                                                            "zh"
                                                              ? item.displayValueCn
                                                              : item.displayValue,
                                                          value: item.codeValue,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.paymentMethod === 1 ||
                                    row.paymentMethod === "1"
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 3 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass:
                                                  "reqired account-label",
                                                attrs: {
                                                  prop:
                                                    "demurrageFees[" +
                                                    index +
                                                    "].paymentAccount",
                                                  label:
                                                    row.paymentBank === "BDO"
                                                      ? _vm.$t(
                                                          "blExchangeAppointment.bankRefNo"
                                                        )
                                                      : _vm.$t(
                                                          "blExchangeAppointment.paymentAccount"
                                                        ),
                                                  rules: [
                                                    {
                                                      required: true,
                                                      message:
                                                        _vm.$t(
                                                          "home.placehold"
                                                        ),
                                                      trigger: [
                                                        "change",
                                                        "blur",
                                                      ],
                                                    },
                                                    {
                                                      validator:
                                                        _vm.validatePaymentAccount,
                                                      trigger: [
                                                        "change",
                                                        "blur",
                                                        "input",
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    maxlength:
                                                      row.paymentBank === "BDO"
                                                        ? 10
                                                        : 15,
                                                    placeholder: _vm.$t(
                                                      "blExchangeAppointment.pleaseInput"
                                                    ),
                                                    disabled:
                                                      row.feeStatus === 1,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.handlePaymentAccountInput(
                                                        $event,
                                                        row,
                                                        index,
                                                        "demurrageFees"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: row.paymentAccount,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "paymentAccount",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "row.paymentAccount",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 2 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].paymentCurrency",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                              label: _vm.$t(
                                                "blExchangeAppointment.currency"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  disabled: row.feeStatus === 1,
                                                },
                                                model: {
                                                  value: row.paymentCurrency,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      row,
                                                      "paymentCurrency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.paymentCurrency",
                                                },
                                              },
                                              _vm._l(
                                                _vm.currencyList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label:
                                                        _vm.language === "zh"
                                                          ? item.labelCN
                                                          : item.labelEh,
                                                      value: item.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 3 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].paymentAmount",
                                              rules: [
                                                {
                                                  required: true,
                                                  message:
                                                    _vm.$t("home.placehold"),
                                                  trigger: "change",
                                                },
                                                {
                                                  validator: function (
                                                    rule,
                                                    value,
                                                    callback
                                                  ) {
                                                    return _vm.validateAmount(
                                                      rule,
                                                      value,
                                                      callback
                                                    )
                                                  },
                                                  trigger: "change",
                                                },
                                              ],
                                              label: _vm.$t(
                                                "blExchangeAppointment.paymentAmount"
                                              ),
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "blExchangeAppointment.pleaseInput"
                                                ),
                                                disabled: row.feeStatus === 1,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.handleAmountInput(
                                                    $event,
                                                    row,
                                                    "paymentAmount"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.paymentAmount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "paymentAmount",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.paymentAmount",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 4 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "reqired",
                                            attrs: {
                                              prop:
                                                "demurrageFees[" +
                                                index +
                                                "].invoiceNumber",
                                              rules: {
                                                required: true,
                                                message:
                                                  _vm.$t("home.placehold"),
                                                trigger: "change",
                                              },
                                              label: _vm.$t(
                                                "blExchangeAppointment.debitNoteNumber"
                                              ),
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "blExchangeAppointment.pleaseInput"
                                                ),
                                                disabled: true,
                                              },
                                              model: {
                                                value: row.invoiceNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "invoiceNumber",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.invoiceNumber",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-col", { attrs: { span: 2 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "5px",
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "align-items": "center",
                                            height: "100%",
                                            gap: "5px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: { width: "90px" },
                                              attrs: { type: "primary" },
                                              on: {
                                                click: _vm.addDemurragesRow,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.addBtn"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                width: "90px",
                                                "margin-right": "10px",
                                              },
                                              attrs: {
                                                type: "danger",
                                                disabled: row.feeStatus === 1,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeDemurrageRow(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.delBtn"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c("el-checkbox", {
                              staticClass: "checkbox-align",
                              attrs: {
                                label: _vm.$t("blExchangeAppointment.taxFlag"),
                                "true-label": 1,
                                "false-label": 0,
                              },
                              model: {
                                value: _vm.form.taxFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "taxFlag", $$v)
                                },
                                expression: "form.taxFlag",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _vm.form.taxFlag === "1" || _vm.form.taxFlag === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.taxAttachment"
                                      ),
                                      prop: "taxAttachment",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "taxAttachment",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "taxAttachment"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: { type: "primary" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "documentType",
                                  label: _vm.$t(
                                    "blExchangeAppointment.documentType"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.form.documentType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "documentType", $$v)
                                      },
                                      expression: "form.documentType",
                                    },
                                  },
                                  _vm._l(_vm.documentTypeList, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label:
                                          _vm.language === "zh"
                                            ? item.labelCN
                                            : item.labelEh,
                                        value: Number(item.value),
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkSURRENDERED ||
                            _vm.checkOBL ||
                            _vm.checkFUC ||
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.containerGuarantee"
                                      ),
                                      prop: "containerGuarantee",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "containerGuarantee",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "containerGuarantee"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .containerGuaranteeFileStatus ||
                                            _vm.fileEditStatus
                                              .containerGuaranteeFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .containerGuaranteeFileStatus ||
                                                _vm.fileEditStatus
                                                  .containerGuaranteeFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkSURRENDERED ||
                            _vm.checkOBL ||
                            _vm.checkFUC ||
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.authorizationLetter"
                                      ),
                                      prop: "authorizationLetter",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "authorizationLetter",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "authorizationLetter"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .authorizationLetterFileStatus ||
                                            _vm.fileEditStatus
                                              .authorizationLetterFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .authorizationLetterFileStatus ||
                                                _vm.fileEditStatus
                                                  .authorizationLetterFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkSURRENDERED ||
                            _vm.checkOBL ||
                            _vm.checkFUC ||
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.insuranceCertificate"
                                      ),
                                      prop: "insuranceCertificate",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "insuranceCertificate",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "insuranceCertificate"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .insuranceCertificateFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .insuranceCertificateFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkSURRENDERED ||
                            _vm.checkOBL ||
                            _vm.checkFUC ||
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.idCardScan"
                                      ),
                                      prop: "idCardScan",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "idCardScan",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "idCardScan"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .idCardScanFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .idCardScanFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkSURRENDERED
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.billOfLadingCopy"
                                      ),
                                      prop: "billOfLadingCopy",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "billOfLadingCopy",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "billOfLadingCopy"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .billOfLadingCopyFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .billOfLadingCopyFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkFUC
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.deliveryOrder"
                                      ),
                                      prop: "deliveryOrder",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "deliveryOrder",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "deliveryOrder"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .deliveryOrderFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .deliveryOrderFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkOBL
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.obl"
                                      ),
                                      prop: "obl",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "oblFileId",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "oblFileId"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .oblFileIdFileStatus,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .oblFileIdFileStatus,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.bankGuaranty"
                                      ),
                                      prop: "bankGuaranty",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "bankGuarantyFileId",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "bankGuarantyFileId"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .bankGuarantyFileIdFileStatus ||
                                            _vm.fileEditStatus
                                              .bankGuarantyFileIdFileStatus ===
                                              1,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.fileEditStatus
                                                  .bankGuarantyFileIdFileStatus ||
                                                _vm.fileEditStatus
                                                  .bankGuarantyFileIdFileStatus ===
                                                  1,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _vm.checkBG
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticClass: "reqired",
                                    attrs: {
                                      label: _vm.$t(
                                        "blExchangeAppointment.oblWithBankStamp"
                                      ),
                                      prop: "oblWithBankStamp",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "oblWithBankStamp",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          multiple: "",
                                          limit: 1,
                                          "http-request": function (file) {
                                            return _vm.uploadFile(
                                              file,
                                              "oblWithBankStamp"
                                            )
                                          },
                                          "on-remove": function (file) {
                                            return _vm.handleRemove(file)
                                          },
                                          "before-remove": _vm.beforeRemove,
                                          "before-upload": _vm.beforeUpload,
                                          "file-list": _vm.fileList,
                                          "on-preview": _vm.handleDownload,
                                          disabled:
                                            _vm.fileEditStatus
                                              .oblWithBankStampFileStatus ||
                                            _vm.form
                                              .oblWithBankStampFileStatus === 1,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "btn-primary",
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.form
                                                  .oblWithBankStampFileStatus ||
                                                _vm.form
                                                  .oblWithBankStampFileStatus ===
                                                  1,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "blExchangeAppointment.uploadAttachment"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-row", [
                      this.checkOBL
                        ? _c("p", { staticClass: "txt-class" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  this.$t(
                                    "blExchangeAppointment.documentTypeInfoOBL"
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.checkBG
                        ? _c("p", { staticClass: "txt-class" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  this.$t(
                                    "blExchangeAppointment.documentTypeInfoBG"
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "item-button" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.forespeakSave")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }